import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function Navbar({ user, handleLogout }) {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <nav className="navbar">
      <h1 className="logo">Ethereal Wedding Fashion</h1>
      <div className="pages">
        <NavLink className="link" to="/">Home</NavLink>
        <NavLink className="link" to="/men">Men</NavLink>
        <NavLink className="link" to="/women">Women</NavLink>
        <NavLink className="link" to="/buy">Buy</NavLink>


        {user ? (
          <div className="user-menu">
            <span 
              className="user-icon" 
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {user.email.charAt(0).toUpperCase()}
            </span>

            {showDropdown && (
              <div className="dropdown">
                <p className="email">{user.email}</p>
                <button className="logout-button" onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        ) : (
          <NavLink className="link" to="/login">Login</NavLink>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
